// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b1066c4","952":"feb98cb6"}[chunkId] + ".chunk.js";
};